import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5975ca1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, " 注：本数据基于您自己选择的区间时间进行回测，根据公开的历史市场数据及相关量化模型模拟运行生成，仅客观呈现特定历史场景下的理论绩效，不构成任何证券投资建议、交易要约或买卖依据，亦不代表本公司对未来投资收益的任何承诺或保证。回测结果具有固有局限性：1.未完全计入交易成本、滑点、税费等实际交易损耗；2.历史数据无法涵盖未来市场波动、政策调整、流动性变化等不可预见因素；3.模型因子及逻辑的有效性可能随市场环境演变而衰减。过往回测表现与未来实际投资结果无必然关联，不保证本金安全及收益实现。投资者应充分认识证券投资的风险性，独立判断、审慎决策，自主承担全部投资风险。 ", -1))

import { ref, onMounted, onUnmounted, computed, watch, h } from 'vue'
import { useRoute } from 'vue-router'
import store from '@/store/index'
import moment from 'moment'
import { mockCurrentHoldings, mockTransactionDetails, fetchTradeDetails } from '@/api/starresultApi'
import StarNoData from '@/components/star/StarNoData.vue'
import StarTemplateLockMask from '@/components/star/StarTemplateLockMask.vue'
import WXQuotationWebSocket from '@/websocket/quotationWebsocket'
import type { TemplateLockState } from '@/utils/useStarTemplateLock'


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionTransactions',
  props: {
    isDark: { type: Boolean },
    holdings: null,
    tradeID: null,
    contentLockState: null
  },
  emits: ["unlock"],
  setup(__props: any, { expose }: { emit: ({ (e: 'unlock'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isDark: boolean
  holdings?: any[]
  tradeID?: string
  /** 体验用户：表格区域锁定状态 */
  contentLockState?: TemplateLockState
}





const tableLocale = computed(() => ({ emptyText: () => h(StarNoData, { isDark: props.isDark }) }))

const tabsVars = computed(() => props.isDark ? {
  '--tab-nav-bg': '#1f1f1f',
  '--tab-inactive-bg': '#1f1f1f',
  '--tab-active-bg': 'rgba(61, 61, 61, 1)',
  '--tab-text': 'rgba(255, 255, 255, 1)',
  '--tab-text-inactive': 'rgba(255, 255, 255, 0.6)',
  '--thead-bg': '#1f1f1f',
  '--thead-text': 'rgba(125, 125, 125, 1)',
  '--row-border': 'none',
  '--row-text': 'rgba(255, 255, 255, 1)',
  '--row-text-secondary': 'rgba(216, 216, 223, 1)',
  '--row-hover-bg': 'rgba(61, 61, 61, 0.5)',
  '--scrollbar-thumb': 'rgba(255,255,255,0.35)',
  '--scrollbar-thumb-hover': 'rgba(255,255,255,0.55)',
} : {
  '--tab-nav-bg': '#ffffff',
  '--tab-inactive-bg': '#ffffff',
  '--tab-active-bg': '#f0f0f0',
  '--tab-text': 'rgba(51, 51, 51, 1)',
  '--tab-text-inactive': 'rgba(153, 153, 153, 1)',
  '--thead-bg': '#f5f5f5',
  '--thead-text': 'rgba(102, 102, 102, 1)',
  '--row-border': 'rgba(240, 240, 240, 1)',
  '--row-text': 'rgba(51, 51, 51, 1)',
  '--row-text-secondary': 'rgba(51, 51, 51, 1)',
  '--row-hover-bg': 'rgba(250, 250, 250, 1)',
  '--scrollbar-thumb': 'rgba(0,0,0,0.15)',
  '--scrollbar-thumb-hover': 'rgba(0,0,0,0.25)',
})

const route = useRoute()
const activeTab = ref('holdings')

// 实时行情：key = `${market}_${symbol}`, value = { lastPrice, updownRate }
const realtimePrices = ref<Record<string, { lastPrice: number; updownRate: number }>>({})
let ws: any = null
const WS_LIST_KEY = 'holdings_list'

const subscribeHoldings = (holdings: any[]) => {
  if (!holdings || holdings.length === 0) return
  if (!ws) {
    ws = new WXQuotationWebSocket()
    ws.connect()
    ws.on(WXQuotationWebSocket.EVENT.onOpen, () => {
      ws.safeSubscribeList(WS_LIST_KEY, holdings.map((h: any) => ({ market: h.market, symbol: h.symbol })))
    })
    ws.on(WXQuotationWebSocket.EVENT.onHQLIST, (data: any) => {
      const list = data?.QuoteData?.DynaData || []
      const updated = { ...realtimePrices.value }
      for (const item of list) {
        // ExchangeID 是小写 sz/sh，统一用小写拼 key
        const key = `${String(item.ExchangeID).toLowerCase()}_${item.InstrumentID}`
        updated[key] = { lastPrice: item.LastPrice, updownRate: item.UpdownRate }
      }
      realtimePrices.value = updated
    })
  } else {
    ws.safeUnsubscribeList(WS_LIST_KEY)
    ws.safeSubscribeList(WS_LIST_KEY, holdings.map((h: any) => ({ market: h.market, symbol: h.symbol })))
  }
}

watch(() => props.holdings, (newHoldings) => {
  if (newHoldings && newHoldings.length > 0) {
    subscribeHoldings(newHoldings)
  }
}, { immediate: true })

onUnmounted(() => {
  if (ws) {
    ws.safeUnsubscribeList(WS_LIST_KEY)
    ws.close()
    ws = null
  }
})

// Holdings
const holdingsData = computed(() => {
  if (props.holdings && props.holdings.length > 0) {
    return props.holdings.map((item: any, index: number) => {
      const rtKey = `${String(item.market).toLowerCase()}_${item.symbol}`
      const rt = realtimePrices.value[rtKey]
      return {
        id: index + 1,
        name: item.name,
        code: item.symbol,
        market: item.market,
        profit: item.profit != null ? parseFloat(item.profit.toFixed(2)) : item.profit,
        currentPrice: rt?.lastPrice != null && rt.lastPrice !== 0
          ? parseFloat(rt.lastPrice.toFixed(2))
          : (item.price != null && item.price !== 0 ? parseFloat(item.price.toFixed(2)) : null),
        costPrice: item.cost != null ? parseFloat(item.cost.toFixed(2)) : item.cost,
        position: (item.rate * 100).toFixed(2) + '%',
        industry: item.hyName
      }
    })
  }
  return []
})
const holdingsColumns = [
  { title: '序', customRender: ({ index }: any) => index + 1, width: 50, align: 'center' },
  { title: '代码', dataIndex: 'code', align: 'left', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text) },
  { title: '名称', dataIndex: 'name', align: 'left' },
  { title: '持仓盈亏', dataIndex: 'profit', slots: { customRender: 'profit' }, align: 'right' },
  { title: '现价', dataIndex: 'currentPrice', slots: { customRender: 'currentPrice' }, align: 'right' },
  { title: '成本价', dataIndex: 'costPrice', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text != null && text !== '' ? Number(text).toFixed(2) : text) },
  { title: '仓位', dataIndex: 'position', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text) },
  { title: '所属行业', dataIndex: 'industry', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text) }
]

// Transactions
const transactionsData = ref<any[]>([])
const totalTransactions = ref(0)
let currentPage = 1
const transactionsColumns = [
  { title: '序', customRender: ({ index }: any) => index + 1, width: 50, align: 'center' },
  { title: '代码', dataIndex: 'code', align: 'left', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text) },
  { title: '名称', dataIndex: 'name', align: 'left' },
  { title: '操作', dataIndex: 'action', slots: { customRender: 'action' }, align: 'right' },
  { title: '成本价', dataIndex: 'costPrice', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text != null && text !== '' ? Number(text).toFixed(2) : text) },
  { title: '成交数量(股)', dataIndex: 'quantity', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text) },
  { title: '成交金额(元)', dataIndex: 'amount', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text != null && text !== '' ? Number(text).toFixed(2) : text) },
  { title: '成交盈亏(元)', dataIndex: 'profit', slots: { customRender: 'profit' }, align: 'right' },
  { title: '日期时间', dataIndex: 'datetime', align: 'right', customRender: ({ text }: any) => h('span', { class: 'secondary-text' }, text) }
]

const getColorClass = (val: number | undefined) => {
  if (val === undefined) return 'black-text'
  if (val > 0) return 'red-text'
  if (val < 0) return 'green-text'
  return 'black-text'
}

const loadMoreTransactions = async () => {
  // if (!props.tradeID) return
  currentPage++
  await getTradeList()
}

const getTradeList = async () => {
  const taskID = (route.query.taskID as string) || (route.params.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
  const token = (route.query.token as string) || (route.params.token as string)
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'

  try {
    const res: any = await fetchTradeDetails({
      data: {
        taskID,
        tradeID: props.tradeID,
        pageNo: currentPage,
        pageSize: 20
      },
      headers: {
        token,
        username
      }
    })

    if (res && res.data) {
      const newList = (res.data.list || []).map((item: any, index: number) => ({
        id: (currentPage - 1) * 20 + index + 1,
        name: item.name,
        code: item.symbol,
        action: item.tradeType === 1 ? '买入' : '卖出',
        costPrice: item.tradePrice != null ? parseFloat(item.tradePrice.toFixed(2)) : item.tradePrice,
        quantity: item.tradeVolume,
        amount: item.tradeValue != null ? parseFloat(item.tradeValue.toFixed(2)) : item.tradeValue,
        profit: item.cumulateProfit != null ? parseFloat(item.cumulateProfit.toFixed(2)) : item.cumulateProfit,
        datetime: moment(item.tradeTime).format('YYYY-MM-DD HH:mm:ss')
      }))

      if (currentPage === 1) {
        transactionsData.value = newList
      } else {
        transactionsData.value = [...transactionsData.value, ...newList]
      }
      totalTransactions.value = res.data.total || 0
    }
  } catch (error) {
    console.error('Failed to fetch trade details:', error)
  }
}

watch(() => props.tradeID, (newID) => {
  if ((route.query.isocbt === '1' || route.query.fromRecord =='1') && !newID) return
  currentPage = 1
  getTradeList()
}, { immediate: true })

onMounted(async () => {
  // Holdings data is now computed from props.holdings
})

expose({ reload: () => { currentPage = 1; getTradeList() } })

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card tabs-card",
    style: _normalizeStyle(_unref(tabsVars))
  }, [
    _createVNode(_component_a_tabs, {
      activeKey: activeTab.value,
      "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "holdings",
          tab: "当前持仓(模拟)"
        }, {
          default: _withCtx(() => [
            _createVNode(StarTemplateLockMask, {
              "lock-state": __props.contentLockState,
              text: "解锁策略明细",
              class: "tab-content-lock",
              onUnlock: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('unlock')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: _unref(holdingsData),
                  columns: holdingsColumns,
                  pagination: false,
                  rowKey: "id",
                  size: "small",
                  locale: _unref(tableLocale)
                }, {
                  profit: _withCtx(({ text }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(getColorClass(text))
                    }, _toDisplayString(text != null ? Number(text).toFixed(2) : '--'), 3)
                  ]),
                  currentPrice: _withCtx(({ text }) => [
                    _createElementVNode("span", null, _toDisplayString(text != null && text !== 0 ? Number(text).toFixed(2) : '--'), 1)
                  ]),
                  _: 1
                }, 8, ["dataSource", "locale"])
              ]),
              _: 1
            }, 8, ["lock-state"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "transactions",
          tab: "交易明细(模拟)"
        }, {
          default: _withCtx(() => [
            _createVNode(StarTemplateLockMask, {
              "lock-state": __props.contentLockState,
              text: "解锁策略明细",
              class: "tab-content-lock",
              onUnlock: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('unlock')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: transactionsData.value,
                  columns: transactionsColumns,
                  pagination: false,
                  rowKey: "id",
                  size: "small",
                  locale: _unref(tableLocale)
                }, {
                  action: _withCtx(({ text }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(text === '买入' ? 'red-text' : 'green-text')
                    }, _toDisplayString(text), 3)
                  ]),
                  profit: _withCtx(({ text }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(getColorClass(text))
                    }, _toDisplayString(text != null ? Number(text).toFixed(2) : '--'), 3)
                  ]),
                  _: 1
                }, 8, ["dataSource", "locale"]),
                (transactionsData.value.length < totalTransactions.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "load-more",
                      onClick: loadMoreTransactions
                    }, " 查看全部" + _toDisplayString(totalTransactions.value) + "次交易记录 ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["lock-state"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _hoisted_1
  ], 4))
}
}

})